var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipHorizontol1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8489 20.8339C18.9331 20.9286 18.9331 21.0714 18.8489 21.1661L13.1869 27.5359C13.0341 27.7077 12.75 27.5997 12.75 27.3698V14.6302C12.75 14.4003 13.0341 14.2923 13.1869 14.4641L18.8489 20.8339Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10L22 32",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1511 21.1661C25.0669 21.0714 25.0669 20.9286 25.1511 20.8339L30.8131 14.4641C30.9659 14.2923 31.25 14.4003 31.25 14.6302L31.25 27.3698C31.25 27.5997 30.9659 27.7077 30.8131 27.5359L25.1511 21.1661Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipHorizontol1);
export default __webpack_public_path__ + "static/media/flip-horizontol1.5df48f148749c559ec93974ab4bb2d05.svg";
export { ForwardRef as ReactComponent };